import React from 'react';

import { useLocalizationContext } from '@order/Localization';

import { useAccountLinks } from '../../hooks';
import { AccountMenuIconRow } from '../AccountMenuIconRow';
import { AccountMenuSecondaryItem } from '../AccountMenuSecondaryItem';

export const AccountSecondaryMenu = () => {
  const { t } = useLocalizationContext();
  const accountLinks = useAccountLinks();

  return (
    <>
      <AccountMenuSecondaryItem
        testID="account-menu.secondary-item.terms"
        label={t('account.sidebar.terms')}
        onPress={accountLinks.handleTermsLink}
      />
      <AccountMenuSecondaryItem
        testID="account-menu.secondary-item.privacy-policy"
        label={t('account.sidebar.privacy-policy')}
        onPress={accountLinks.handlePrivacyLink}
      />
      <AccountMenuSecondaryItem
        testID="account-menu.secondary-item.do-not-sell"
        label={t('account.sidebar.do-not-sell')}
        onPress={accountLinks.handlePersonalInfoLink}
      />
      <AccountMenuIconRow />
    </>
  );
};
